import { getResultPoolRequestIds, getResult } from "Redux/Query";

export const getMissingResultPoolRequestIds = state =>
    getResultPoolRequestIds(state).filter( id => !getResult(state, id));